import { DEFAULT_CURRENCY_CODE_RECEIVED } from '../actions/constants/ActionTypes';
const initialState = null;
const DefaultCurrencyCode = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case DEFAULT_CURRENCY_CODE_RECEIVED:
      return payload;
    default:
      return state;
  }
};
export default DefaultCurrencyCode;